module.exports = __webpack_public_path__ + "img/benoit23.b13ac1f2.jpg";